/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_EyebrowInputs */

const en_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const es_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const de_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungen`)
};

const zh_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动`)
};

const ar_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفعاليات`)
};

const fr_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements`)
};

const vi_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện`)
};

const sw_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio`)
};

const th_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรม`)
};

const bs_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Događaji`)
};

const ja_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント`)
};

const ko_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트`)
};

const pt_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos`)
};

const it_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi`)
};

const sv_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenemang`)
};

const nl_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenementen`)
};

const da_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementer`)
};

const nb_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementer`)
};

const fi_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtumat`)
};

const pl_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenia`)
};

const ru_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятия`)
};

const tr_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlikler`)
};

const hi_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम`)
};

const id_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const ms_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara`)
};

const cs_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const el_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εκδηλώσεις`)
};

const he_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירועים`)
};

const af_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleenthede`)
};

const hu_events_eyebrow = /** @type {(inputs: Events_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Események`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Events_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_eyebrow = /** @type {((inputs?: Events_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_eyebrow(inputs)
	if (locale === "de") return de_events_eyebrow(inputs)
	if (locale === "zh") return zh_events_eyebrow(inputs)
	if (locale === "ar") return ar_events_eyebrow(inputs)
	if (locale === "fr") return fr_events_eyebrow(inputs)
	if (locale === "vi") return vi_events_eyebrow(inputs)
	if (locale === "sw") return sw_events_eyebrow(inputs)
	if (locale === "th") return th_events_eyebrow(inputs)
	if (locale === "bs") return bs_events_eyebrow(inputs)
	if (locale === "ja") return ja_events_eyebrow(inputs)
	if (locale === "ko") return ko_events_eyebrow(inputs)
	if (locale === "pt") return pt_events_eyebrow(inputs)
	if (locale === "it") return it_events_eyebrow(inputs)
	if (locale === "sv") return sv_events_eyebrow(inputs)
	if (locale === "nl") return nl_events_eyebrow(inputs)
	if (locale === "da") return da_events_eyebrow(inputs)
	if (locale === "nb") return nb_events_eyebrow(inputs)
	if (locale === "fi") return fi_events_eyebrow(inputs)
	if (locale === "pl") return pl_events_eyebrow(inputs)
	if (locale === "ru") return ru_events_eyebrow(inputs)
	if (locale === "tr") return tr_events_eyebrow(inputs)
	if (locale === "hi") return hi_events_eyebrow(inputs)
	if (locale === "id") return id_events_eyebrow(inputs)
	if (locale === "ms") return ms_events_eyebrow(inputs)
	if (locale === "cs") return cs_events_eyebrow(inputs)
	if (locale === "el") return el_events_eyebrow(inputs)
	if (locale === "he") return he_events_eyebrow(inputs)
	if (locale === "af") return af_events_eyebrow(inputs)
	if (locale === "hu") return hu_events_eyebrow(inputs)
	return en_events_eyebrow(inputs)
});